module.exports = __webpack_public_path__ + "img/Movie Key.adea7c82.png";